import { useContext } from "react"
import { TextContext } from "../components/TextsProvider/textsProvider"

export const useTexts = () => useContext(TextContext)
